import React from 'react';
import styled from 'styled-components';
import { Heading3, Heading6 } from '@latitude/heading';
import { Box } from '../Box/Box';
import {
  ALIGN,
  BREAKPOINT,
  COLOR,
  MARGIN,
  POSITION
} from '../../utils/constants';
import SmallSvg from './svg/confetti-stamps-small.svg';
import LargeSvg from './svg/confetti-stamps-large.svg';
import LeftLargeSvg from './svg/confetti-stamps-left-large.svg';

// TODO: Incorporate styles for pink bg (in softquote) and left confetti (results page)
const HeadingContainer = styled(Box)`
  text-align: center;
  h6 {
    position: ${POSITION.RELATIVE};
    display: inline-block;
    text-align: ${props => props.textAlign ?? 'center'};
    background-color: ${props =>
      props.textBackgroundColor ?? COLOR.TRANSPARENT};
    ${props =>
      props.size == 'Large'
        ? `
      padding: 8px 20px;
      @media (max-width: '320px') {
        margin-left: -20px;
        padding: 8px 4px;
        font-size: 14px;
      }
      @media (max-width: ${BREAKPOINT.XS}) {
        padding: 8px 16px;
        margin-left: -20px;
        font-size: 14px;
      }`
        : ''};
  }
  h6:after {
    content: '';
    background: url(${props => (props.size == 'Large' ? LargeSvg : SmallSvg)})
      top right no-repeat;
    position: ${POSITION.ABSOLUTE};
    width: ${props => props.imageWidth ?? '40px'};
    height: ${props => props.imageHeight ?? '34px'};
    top: ${props => props.imageTop ?? '-14px'};
    right: ${props => props.imageTop ?? '-20px'};
  }

  h3 {
    position: ${POSITION.RELATIVE};
    display: inline;
    text-align: ${props => props.textAlign ?? 'center'};
    margin: 0px;
    font-family: 'Montserrat', sans-serif;
    font-weight: 600;
    font-size: 32px;
    line-height: 36px;
    -webkit-letter-spacing: -0.7px;
    -moz-letter-spacing: -0.7px;
    -ms-letter-spacing: -0.7px;
    letter-spacing: -0.7px;
    color: ${COLOR.BLACK};
    text-align: ${ALIGN.CENTER};
    @media (max-width: ${BREAKPOINT.XS}) {
      max-width: 279px;
    }
    @media (max-width: 320px) {
      max-width: 250px;
    }
  }

  h3:before {
    content: '';
    background: url(${LeftLargeSvg}) top left no-repeat;
    position: ${POSITION.ABSOLUTE};
    width: 70px;
    height: 56px;
    top: -26px;
    left: -35px;
  }
`;

const ConfettiText = props => {
  const {
    text,
    header,
    backgroundColor,
    size,
    imageWidth,
    imageHeight,
    imageTop,
    textBackgroundColor
  } = props;

  return (
    <HeadingContainer
      backgroundColor={backgroundColor}
      size={size}
      imageWidth={imageWidth}
      imageHeight={imageHeight}
      imageTop={imageTop}
      textBackgroundColor={textBackgroundColor}
    >
      {header && <Heading3>{text}</Heading3>}
      {!header && (
        <Heading6
          marginBottom={`${MARGIN.M8}`}
          marginTop={`${MARGIN.M8}`}
          color={COLOR.BLACK}
        >
          {text}
        </Heading6>
      )}
    </HeadingContainer>
  );
};

export default ConfettiText;
